/* Kieszonkowe Inc. — Wybór Paczkomatu InPost na interaktywnej mapie */
(() => {
  let leafletMap = null;
  let markersLayer = null;
  let selectedModalPoint = null;
  let activeCallback = null;
  let currentModalEl = null;

  // Ikona markera InPost (żółta pinezka z paczką)
  const inpostMarkerSvg = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="36" height="44" viewBox="0 0 36 44"><path fill="%23FFCC00" stroke="%23111214" stroke-width="2.5" d="M18 1C8.6 1 1 8.6 1 18c0 14.5 17 25 17 25s17-10.5 17-25C35 8.6 27.4 1 18 1z"/><circle fill="%23111214" cx="18" cy="18" r="11"/><text x="18" y="22" fill="%23FFCC00" font-size="12" font-family="monospace" font-weight="bold" text-anchor="middle">📦</text></svg>`;

  function initInpostPicker() {
    const wraps = document.querySelectorAll('[data-k-inpost]');
    if (!wraps.length) return;

    wraps.forEach((wrap) => {
      if (wrap.dataset.kInitialized) return;
      wrap.dataset.kInitialized = 'true';

      const methodInputs = wrap.querySelectorAll('input[name="k_delivery_method"]');
      const box = wrap.querySelector('[data-k-paczkomat-box]');
      const selectedView = wrap.querySelector('[data-k-selected]');
      const pickerView = wrap.querySelector('[data-k-picker]');
      const codeDisplay = wrap.querySelector('[data-k-code]');
      const descDisplay = wrap.querySelector('[data-k-desc]');
      const errorMsg = wrap.querySelector('[data-k-error]');
      const modal = wrap.querySelector('[data-k-modal]');

      // Przenosimy modal bezpośrednio do body, aby nie był ucinany przez transform w cart-drawer
      if (modal && modal.parentElement !== document.body) {
        currentModalEl = modal;
        document.body.appendChild(modal);
      } else if (modal) {
        currentModalEl = modal;
      }

      let currentMethod = wrap.querySelector('input[name="k_delivery_method"]:checked')?.value || 'Paczkomat InPost';
      let currentCode = codeDisplay?.textContent?.trim() || '';

      const updateCartAttributes = async (attributes) => {
        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes }),
          });
          return await res.json();
        } catch (e) {
          console.error('[InPost] Błąd zapisu atrybutów koszyka:', e);
        }
      };

      const setPoint = async (code, desc) => {
        const cleanCode = code.toUpperCase().trim();
        const fullDesc = desc || cleanCode;
        currentCode = cleanCode;

        if (codeDisplay) codeDisplay.textContent = cleanCode;
        if (descDisplay) descDisplay.textContent = fullDesc;

        selectedView?.classList.remove('is-hidden');
        pickerView?.classList.add('is-hidden');
        errorMsg?.classList.add('is-hidden');

        if (currentModalEl) {
          currentModalEl.classList.add('is-hidden');
          currentModalEl.setAttribute('aria-hidden', 'true');
        }

        await updateCartAttributes({
          'Metoda_Dostawy': 'Paczkomat InPost',
          'Paczkomat': fullDesc,
          'Paczkomat_Kod': cleanCode,
        });
      };

      // Zmiana metody dostawy
      methodInputs.forEach((input) => {
        input.addEventListener('change', async () => {
          currentMethod = input.value;
          wrap.querySelectorAll('.k-inpost__method').forEach((m) => m.classList.remove('is-active'));
          input.closest('.k-inpost__method')?.classList.add('is-active');

          if (currentMethod === 'Paczkomat InPost') {
            box?.classList.remove('is-hidden');
            if (currentCode) {
              await updateCartAttributes({ 'Metoda_Dostawy': 'Paczkomat InPost' });
            }
          } else {
            box?.classList.add('is-hidden');
            errorMsg?.classList.add('is-hidden');
            await updateCartAttributes({
              'Metoda_Dostawy': 'Kurier',
              'Paczkomat': '',
              'Paczkomat_Kod': '',
            });
            currentCode = '';
            selectedView?.classList.add('is-hidden');
            pickerView?.classList.remove('is-hidden');
          }
        });
      });

      // Otwieranie mapy z poziomu koszyka
      wrap.querySelectorAll('[data-k-action="open-map"]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          openMapModal(setPoint);
        });
      });
    });

    // Strażnik przejścia do kasy
    document.querySelectorAll('form[action="/cart"], #CartDrawer-Form, form[action^="/checkout"]').forEach((form) => {
      if (form.dataset.kGuardAttached) return;
      form.dataset.kGuardAttached = 'true';

      const validateCheckout = (e) => {
        const activeWrap = document.querySelector('[data-k-inpost]');
        if (!activeWrap) return true;

        const isPaczkomat = activeWrap.querySelector('input[name="k_delivery_method"]:checked')?.value === 'Paczkomat InPost';
        const code = activeWrap.querySelector('[data-k-code]')?.textContent?.trim() || '';

        if (isPaczkomat && !code) {
          e.preventDefault();
          e.stopPropagation();

          const error = activeWrap.querySelector('[data-k-error]');
          if (error) {
            error.textContent = '⚠️ Wybierz Paczkomat na mapie przed przejściem do kasy!';
            error.classList.remove('is-hidden');
          }
          openMapModal((c, d) => {
            const codeDisplay = activeWrap.querySelector('[data-k-code]');
            const descDisplay = activeWrap.querySelector('[data-k-desc]');
            if (codeDisplay) codeDisplay.textContent = c;
            if (descDisplay) descDisplay.textContent = d;
            activeWrap.querySelector('[data-k-selected]')?.classList.remove('is-hidden');
            activeWrap.querySelector('[data-k-picker]')?.classList.add('is-hidden');
            error?.classList.add('is-hidden');
          });
          return false;
        }
        return true;
      };

      form.addEventListener('submit', validateCheckout);
      form.querySelectorAll('[name="checkout"], #CartDrawer-Checkout, #checkout').forEach((btn) => {
        btn.addEventListener('click', validateCheckout);
      });
    });
  }

  function openMapModal(onSelectCallback) {
    const modal = currentModalEl || document.querySelector('[data-k-modal]');
    if (!modal) return;

    activeCallback = onSelectCallback;
    modal.classList.remove('is-hidden');
    modal.setAttribute('aria-hidden', 'false');

    setupLeaflet(modal);
  }

  function setupLeaflet(modal) {
    const mapContainer = modal.querySelector('[data-k-map-container]');
    const statusEl = modal.querySelector('[data-k-map-status]');
    const searchInput = modal.querySelector('[data-k-map-search-input]');
    const searchBtn = modal.querySelector('[data-k-action="map-search-btn"]');
    const geoBtn = modal.querySelector('[data-k-action="map-geo-btn"]');
    const quickList = modal.querySelector('[data-k-quick-list]');
    const pointDetails = modal.querySelector('[data-k-modal-point]');
    const codeEl = modal.querySelector('[data-k-modal-code]');
    const descEl = modal.querySelector('[data-k-modal-desc]');
    const hintEl = modal.querySelector('.k-inpost-modal__selection-hint');
    const confirmBtn = modal.querySelector('[data-k-action="confirm-modal-point"]');

    // Zamknięcie
    modal.querySelectorAll('[data-k-action="close-modal"]').forEach((btn) => {
      btn.onclick = () => {
        modal.classList.add('is-hidden');
        modal.setAttribute('aria-hidden', 'true');
      };
    });

    const ensureLeaflet = () => {
      if (typeof window.L !== 'undefined') {
        buildMap();
      } else {
        // Dynamiczne doładowanie jeśli jeszcze nie gotowe
        if (!document.getElementById('leaflet-css')) {
          const link = document.createElement('link');
          link.id = 'leaflet-css';
          link.rel = 'stylesheet';
          link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
          document.head.appendChild(link);
        }
        if (!document.getElementById('leaflet-js')) {
          const script = document.createElement('script');
          script.id = 'leaflet-js';
          script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
          script.onload = () => buildMap();
          document.head.appendChild(script);
        } else {
          setTimeout(ensureLeaflet, 100);
        }
      }
    };

    const buildMap = () => {
      if (!leafletMap && mapContainer) {
        leafletMap = L.map(mapContainer, {
          center: [52.2297, 21.0122], // Domyślnie Warszawa / centrum Polski
          zoom: 13,
          zoomControl: true,
        });

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '© OpenStreetMap | InPost',
        }).addTo(leafletMap);

        markersLayer = L.layerGroup().addTo(leafletMap);

        // Doczytywanie przy przesuwaniu mapy
        leafletMap.on('moveend', () => {
          const center = leafletMap.getCenter();
          fetchPointsByCoords(center.lat, center.lng);
        });
      }

      setTimeout(() => {
        if (leafletMap) {
          leafletMap.invalidateSize();
          const center = leafletMap.getCenter();
          fetchPointsByCoords(center.lat, center.lng);
        }
      }, 150);
    };

    const inpostIcon = typeof window.L !== 'undefined' ? L.icon({
      iconUrl: inpostMarkerSvg,
      iconSize: [36, 44],
      iconAnchor: [18, 44],
      popupAnchor: [0, -40],
    }) : null;

    const selectPoint = (code, desc) => {
      selectedModalPoint = { code, desc };
      if (codeEl) codeEl.textContent = code;
      if (descEl) descEl.textContent = desc;
      pointDetails?.classList.remove('is-hidden');
      hintEl?.classList.add('is-hidden');
      confirmBtn?.classList.remove('is-hidden');
    };

    const confirmSelection = (code, desc) => {
      if (activeCallback) {
        activeCallback(code, desc);
      }
      modal.classList.add('is-hidden');
      modal.setAttribute('aria-hidden', 'true');
    };

    confirmBtn.onclick = () => {
      if (selectedModalPoint) {
        confirmSelection(selectedModalPoint.code, selectedModalPoint.desc);
      }
    };

    const renderPoints = (items) => {
      if (!markersLayer || !leafletMap) return;
      markersLayer.clearLayers();

      if (quickList) quickList.innerHTML = '';

      if (!items || !items.length) {
        if (statusEl) {
          statusEl.textContent = 'Brak Paczkomatów w wybranym miejscu. Przesuń mapę lub wpisz inne miasto.';
          statusEl.classList.remove('is-hidden');
        }
        return;
      }

      statusEl?.classList.add('is-hidden');

      // Lista 6 najbliższych Paczkomatów do szybkiego wyboru pod mapą
      const nearestItems = items.slice(0, 6);
      if (quickList) {
        const title = document.createElement('div');
        title.className = 'k-inpost-quick-title';
        title.textContent = 'NAJBLIŻSZE PACZKOMATY (KLIKNIJ, ABY WYBRAĆ):';
        quickList.appendChild(title);

        const listWrap = document.createElement('div');
        listWrap.className = 'k-inpost-quick-items';

        nearestItems.forEach((item) => {
          const code = item.name;
          const address = `${item.address?.line1 || ''}, ${item.address?.line2 || ''}`;
          const fullDesc = `${code} — ${address} ${item.location_description ? '(' + item.location_description + ')' : ''}`.trim();

          const card = document.createElement('div');
          card.className = 'k-inpost-quick-card';
          card.innerHTML = `
            <div class="k-inpost-quick-info">
              <strong>📦 ${code}</strong>
              <span>${address}</span>
            </div>
            <button type="button" class="button button--secondary k-inpost-quick-btn">WYBIERZ</button>
          `;

          card.querySelector('button').addEventListener('click', (e) => {
            e.stopPropagation();
            confirmSelection(code, fullDesc);
          });

          card.addEventListener('click', () => {
            leafletMap.setView([item.location.latitude, item.location.longitude], 16);
            selectPoint(code, fullDesc);
          });

          listWrap.appendChild(card);
        });

        quickList.appendChild(listWrap);
      }

      // Znaczniki na mapie
      items.forEach((item) => {
        if (!item.location?.latitude || !item.location?.longitude) return;
        const code = item.name;
        const address = `${item.address?.line1 || ''}, ${item.address?.line2 || ''}`;
        const fullDesc = `${code} — ${address} ${item.location_description ? '(' + item.location_description + ')' : ''}`.trim();

        const marker = L.marker([item.location.latitude, item.location.longitude], {
          icon: inpostIcon || new L.Icon.Default(),
          title: code,
        });

        const popupDiv = document.createElement('div');
        popupDiv.className = 'k-inpost-popup';
        popupDiv.innerHTML = `
          <strong>📦 PACZKOMAT ${code}</strong><br>
          <span>${address}</span><br>
          <small style="opacity:0.8">${item.location_description || ''}</small><br>
          <button type="button" class="button button--primary" style="margin-top:10px;padding:8px 14px;font-size:12px;width:100%;letter-spacing:0.04em;">
            WYBIERZ TEN PACZKOMAT
          </button>
        `;

        popupDiv.querySelector('button').addEventListener('click', () => {
          confirmSelection(code, fullDesc);
        });

        marker.bindPopup(popupDiv);
        marker.on('click', () => {
          selectPoint(code, fullDesc);
        });

        markersLayer.addLayer(marker);
      });
    };

    const fetchPointsByCoords = async (lat, lng) => {
      if (statusEl) {
        statusEl.textContent = 'Szukanie Paczkomatów w okolicy...';
        statusEl.classList.remove('is-hidden');
      }

      try {
        const res = await fetch(`https://api-shipx-pl.easypack24.net/v1/points?relative_point=${lat},${lng}&max_distance=6000&limit=30`);
        const data = await res.json();
        renderPoints(data.items || []);
      } catch (err) {
        console.error('Błąd pobierania punktów InPost:', err);
        if (statusEl) {
          statusEl.textContent = 'Błąd ładowania punktów. Sprawdź połączenie internetowe.';
        }
      }
    };

    const searchAddressOrCity = async (query) => {
      const q = query.trim();
      if (!q) return;

      if (statusEl) {
        statusEl.textContent = `Wyszukiwanie: "${q}"...`;
        statusEl.classList.remove('is-hidden');
      }

      // Sprawdzenie czy to kod Paczkomatu
      try {
        const res = await fetch(`https://api-shipx-pl.easypack24.net/v1/points?name=${encodeURIComponent(q.toUpperCase())}`);
        const data = await res.json();
        if (data.items?.length) {
          renderPoints(data.items);
          const p = data.items[0];
          leafletMap.setView([p.location.latitude, p.location.longitude], 16);
          selectPoint(p.name, `${p.name} — ${p.address?.line1 || ''}, ${p.address?.line2 || ''}`);
          return;
        }
      } catch (e) {}

      // Wyszukiwanie po mieście przez InPost API
      try {
        const res = await fetch(`https://api-shipx-pl.easypack24.net/v1/points?city=${encodeURIComponent(q)}&limit=30`);
        const data = await res.json();
        if (data.items?.length) {
          renderPoints(data.items);
          const p = data.items[0];
          leafletMap.setView([p.location.latitude, p.location.longitude], 13);
          return;
        }
      } catch (e) {}

      // Geokodowanie OpenStreetMap Nominatim dla ulic/dzielnic
      try {
        const geoRes = await fetch(`https://nominatim.openstreetmap.org/search?format=json&countrycodes=pl&q=${encodeURIComponent(q)}`);
        const geoData = await geoRes.json();
        if (geoData?.length) {
          const lat = parseFloat(geoData[0].lat);
          const lon = parseFloat(geoData[0].lon);
          leafletMap.setView([lat, lon], 14);
          fetchPointsByCoords(lat, lon);
          return;
        }
      } catch (e) {}

      if (statusEl) {
        statusEl.textContent = `Nie znaleziono lokalizacji dla "${q}". Spróbuj wpisać nazwę miasta.`;
      }
    };

    if (searchBtn && searchInput) {
      searchBtn.onclick = () => searchAddressOrCity(searchInput.value);
      searchInput.onkeydown = (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          searchAddressOrCity(searchInput.value);
        }
      };
    }

    if (geoBtn) {
      geoBtn.onclick = () => {
        if (!navigator.geolocation) {
          alert('Twoja przeglądarka nie obsługuje geolokalizacji.');
          return;
        }
        if (statusEl) {
          statusEl.textContent = 'Pobieranie Twojej lokalizacji...';
          statusEl.classList.remove('is-hidden');
        }
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const lat = pos.coords.latitude;
            const lng = pos.coords.longitude;
            leafletMap.setView([lat, lng], 14);
            fetchPointsByCoords(lat, lng);
          },
          () => {
            if (statusEl) {
              statusEl.textContent = 'Nie udało się pobrać lokalizacji. Wpisz miasto w wyszukiwarku.';
            }
          }
        );
      };
    }

    ensureLeaflet();
  }

  // Automatyczna inicjalizacja
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInpostPicker);
  } else {
    initInpostPicker();
  }

  document.addEventListener('cart:updated', () => setTimeout(initInpostPicker, 150));
  document.addEventListener('change', (e) => {
    if (e.target.matches('.cart-item__quantity input, .quantity__input')) {
      setTimeout(initInpostPicker, 300);
    }
  });
})();
